import { ConversationInsightsFiltersV1Schema } from "@redotech/redo-support-common/conversation-filters/conversation-insights-filters";
import { ConversationInsightsItemSchema } from "@redotech/redo-support-common/conversation-insights";
import * as z from "zod";

export const getConversationInsights = {
  name: "getConversationInsights" as const,
  input: z.object({
    pageNumber: z.number().optional(),
    pageSize: z.number().int().positive(),
    filters: ConversationInsightsFiltersV1Schema.optional(),
  }),
  output: z.object({ data: z.array(ConversationInsightsItemSchema) }),
};
